import React from 'react';

import { PriceSize } from '@/components/switchback/Price';
import PriceCurrent from '@/components/switchback/Price/PriceCurrent';
import PriceInstantBook from '@/components/switchback/Price/PriceInstantBook';
import { defaultLocale, TCurrency } from '@/config/locales';
import { PriceType } from '@/redux/selectors/listing/page';
import { TEstimatedPriceBreakdown } from '@/services/types/search/rentals/id';

interface TPriceDetailsProps {
  currency?: TCurrency;
  originalPrice: number;
  currentPrice: number;
  instantBook?: boolean;
  period: PriceType;
  size?: PriceSize;
  showDiscount: boolean;
  isBillSection?: boolean;
  priceClassName?: string;
  estimatedPriceBreakdown?: TEstimatedPriceBreakdown;
  isRVBundle?: boolean;
  nights?: number;
}

export const PriceDetails = ({
  currency = defaultLocale.base_currency,
  originalPrice,
  currentPrice,
  estimatedPriceBreakdown,
  instantBook = false,
  period,
  size = PriceSize.small,
  showDiscount,
  isBillSection = false,
  priceClassName,
  isRVBundle = false,
  nights,
}: TPriceDetailsProps) => {
  const hasDiscount = currentPrice < originalPrice;

  return (
    <div className="flex flex-col justify-center gap-1">
      <div className={`flex ${priceClassName}`}>
        {instantBook && !isRVBundle && (
          <PriceInstantBook
            className="self-center flex-shrink-0"
            size={isBillSection ? PriceSize.large : PriceSize.medium}
          />
        )}
        <PriceCurrent
          size={size}
          currency={currency}
          currentPrice={currentPrice}
          originalPrice={originalPrice}
          period={period}
          isCampsite
          isRVBundle={isRVBundle}
          totalPrice={estimatedPriceBreakdown?.total}
          nights={nights}
          originalTotalPrice={estimatedPriceBreakdown?.original_total}
          showDiscount={showDiscount}
          hasDiscount={hasDiscount}
        />
      </div>
    </div>
  );
};
